import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "as-schematic-item" }
const _hoisted_2 = { class: "as-schematic-item__body" }
const _hoisted_3 = { class: "as-schematic-player as-schematic-player__home" }
const _hoisted_4 = { class: "as-schematic-info" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "as-schematic-info__imgNull"
}
const _hoisted_7 = { class: "as-schematic-player as-schematic-player__away" }
const _hoisted_8 = { class: "as-schematic-info" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "as-schematic-info__imgNull"
}

import { ref, computed } from "vue";

const __default__ = {};

interface IProps {
    isNull: boolean;
  }


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SchematicItem',
  props: {
    isNull: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.isNull)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "as-schematic-info__img",
                src: _ctx.getImgUrlBySport('player', '4wyrn1tvowkq86p', true, 'basketball')
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.isNull)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["as-schematic-info__name", {'isNull' : _ctx.isNull}])
          }, _toDisplayString(_ctx.isNull ? '-' : 'Elias G.'), 3)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["as-schematic-score", {'isNull' : _ctx.isNull}])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.isNull ? '-' : 0), 1)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.isNull)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "as-schematic-info__img",
                src: _ctx.getImgUrlBySport('player', '4wyrn1tvowkq86p', true, 'basketball')
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.isNull)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["as-schematic-info__name", {'isNull' : _ctx.isNull}])
          }, _toDisplayString(_ctx.isNull ? '-' : 'Elias G.'), 3)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["as-schematic-score", {'isNull' : _ctx.isNull}])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.isNull ? '-' : 0), 1)
        ], 2)
      ])
    ])
  ]))
}
}

})